export default [
  {
    url: '/back',
    name: '사무소 바로가기',
    slug: 'home',
    icon: 'ArrowLeftIcon'
  },
  {
    url: '/home',
    name: '대시보드',
    slug: 'home',
    icon: 'CircleIcon'
  },
  {
    url: '/plan',
    name: '사무소 개요',
    slug: 'plan',
    icon: 'CircleIcon',
    submenu: [
      {
        url: '/plan/project',
        name: '사무소 정보',
        slug: 'plan-project',
        icon: 'CircleIcon'
      },
      {
        url: '/plan/partners/list',
        name: '파트너사 계약 현황',
        slug: 'plan-partners',
        icon: 'CircleIcon'
      },
      {
        url: '/plan/partners/join',
        name: '파트너사 등록 요청',
        slug: '',
        icon: 'CircleIcon'
      }
    ]
  },
  {
    url: '/list/report/project_monthly_report',
    name: '안전·보건예산 현황',
    slug: 'report',
    icon: 'CircleIcon'
  },
  {
    url: '/',
    name: '산업재해발생',
    slug: 'report',
    icon: 'CircleIcon',
    submenu: [
      {
        url: '/list/accident/accident_report',
        name: '안전사고',
        slug: 'safety-accident',
        icon: 'CircleIcon'
      },
    ]
  },
  {
    url: '/hse',
    name: '안전·보건 교육',
    slug: 'hse',
    icon: 'CircleIcon',
    submenu: [
      {
        url: '/hse/list',
        name: '교육 현황',
        slug: 'hse-list',
        icon: 'CircleIcon'
      },
      {
        url: '/hse/monitoring',
        name: '교육 모니터링',
        slug: 'hse-monitoring',
        icon: 'CircleIcon'
      }
    ]
  },
  {
    url: '/risk',
    name: '위험성평가',
    slug: 'risk',
    icon: 'CircleIcon',
    submenu: [
      {
        url: '/risk/assessment',
        name: '위험성평가',
        slug: 'risk-assessment',
        icon: 'CircleIcon'
      },
      {
        url: '/risk/conference',
        name: '협의체회의',
        slug: 'risk-conference',
        icon: 'CircleIcon'
      }
    ]
  },
  {
    url: '/',
    name: '작업허가서',
    slug: 'risk-permit',
    icon: 'CircleIcon',
    submenu: [
      {
        url: '/risk/permit',
        name: '작업허가서',
        slug: 'risk-permit',
        icon: 'CircleIcon'
      }
    ]
  },
  {
    url: '/',
    name: '안전점검',
    slug: 'risk-check',
    icon: 'CircleIcon',
    submenu: [
      {
        url: '/list/safety_check/safety_check_444',
        name: '안전점검',
        slug: 'risk-check',
        icon: 'CircleIcon'
      }
    ]
  },
  {
    url: '/prevention',
    name: '시정 및 예방요청서',
    slug: 'prevention',
    icon: 'CircleIcon',
    submenu: [
      {
        url: '/prevention/request',
        name: '안전/보건',
        slug: 'prevention-request',
        icon: 'CircleIcon'
      }
    ]
  },
  {
    url: '/safety',
    name: '파트너사 일일보고',
    slug: 'safety',
    icon: 'CircleIcon',
    submenu: [
      {
        url: '/safety/director',
        name: '안전보건책임자 선임',
        slug: 'safety-director',
        icon: 'CircleIcon'
      },
      {
        url: '/list/safety_check_partner/safety_check_partner_444',
        name: '안전점검',
        slug: 'safety-check',
        icon: 'CircleIcon'
      },
      {
        url: '/safety/equipment',
        name: '장비점검 현황',
        slug: 'safety-equipment',
        icon: 'CircleIcon'
      }
    ]
  },
  {
    url: '/community',
    name: '커뮤니티',
    slug: 'community',
    icon: 'CircleIcon',
    submenu: [
      {
        url: '/community/businessnews',
        name: 'CEO 메세지',
        slug: 'community_businessnews',
        icon: 'CircleIcon'
      },
      {
        url: '/community/healthinfo',
        name: '안전보건 주요일정',
        slug: 'community_healthinfo',
        icon: 'CircleIcon'
      },
      {
        url: '/community/unitbusinessnews',
        name: '구성원 요청사항',
        slug: 'community_unitbusinessnews',
        icon: 'CircleIcon'
      },
      {
        url: '/community/qna',
        name: 'Q&A',
        slug: 'community_qna',
        icon: 'CircleIcon'
      }
    ]
  },
  {
    url: '/mypage',
    name: '마이페이지',
    slug: 'safety',
    icon: 'CircleIcon',
    submenu: [
      {
        url: '/mypage/workstatus',
        name: '업무현황',
        slug: '',
        icon: 'CircleIcon'
      },
      {
        url: '/mypage/alert',
        name: '알림',
        slug: '',
        icon: 'CircleIcon'
      },
      {
        url: '/',
        name: '결재관리',
        slug: '',
        icon: 'CircleIcon',
        submenu: [
          {
            url: '/approval-request',
            name: '결재요청함',
            slug: '',
            icon: 'CircleIcon'
          },
          {
            url: '/approval-await',
            name: '결재대기함',
            slug: '',
            icon: 'CircleIcon'
          },
          {
            url: '/approval-process',
            name: '결재진행함',
            slug: '',
            icon: 'CircleIcon'
          },
          {
            url: '/approval-complete',
            name: '완료문서함',
            slug: '',
            icon: 'CircleIcon'
          },
          {
            url: '/approval-reject',
            name: '반려문서함',
            slug: '',
            icon: 'CircleIcon'
          },
          {
            url: '/approval-reference',
            name: '참조/회람문서함',
            slug: '',
            icon: 'CircleIcon'
          },
        ]
      },
      {
        url: '/',
        name: '설정',
        slug: '',
        icon: 'CircleIcon',
        submenu: [
          {
            url: '/mypage/info-update',
            name: '개인정보변경',
            slug: '',
            icon: 'CircleIcon'
          },
        ]
      }
    ]
  }
]
